export const THREE_MINUTE_WARNING_SECONDS = 3 * 60;
export const MEETING_END_WARNING_PREFIX = 'meeting.end-warning.v1';

export const formatMeetingRemaining = (seconds) => {
  const value = Math.max(0, Math.ceil(Number(seconds) || 0));
  const hours = Math.floor(value / 3600);
  const minutes = Math.floor((value % 3600) / 60);
  const secs = value % 60;
  return `${hours ? `${String(hours).padStart(2, '0')}:` : ''}${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
};

export const getMeetingEndWarningKey = (roomId, endAt) =>
  `${MEETING_END_WARNING_PREFIX}:${String(roomId || '')}:${Number(endAt) || 0}`;

export const shouldShowThreeMinuteWarning = ({
  remainingSeconds,
  alertKey,
  lastAlertKey = '',
  wasPersisted = false,
} = {}) => {
  const remaining = Number(remainingSeconds);
  return Boolean(
    alertKey &&
    Number.isFinite(remaining) &&
    remaining > 0 &&
    remaining <= THREE_MINUTE_WARNING_SECONDS &&
    alertKey !== lastAlertKey &&
    !wasPersisted
  );
};

export const readMeetingEndWarning = (key, storage = globalThis.sessionStorage) => {
  try { return storage?.getItem(key) === 'shown'; } catch { return false; }
};

export const persistMeetingEndWarning = (key, storage = globalThis.sessionStorage) => {
  try { storage?.setItem(key, 'shown'); } catch {}
};

